/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { InviteUser } from '../../../store/User/userActions';
import AuthLoader from '../../Loader/Auth';
import { emailRegex, notification } from '../../../assets/constants/strings';

const UserAddModal = ({ loading, user, InviteUser, error, usersByClient }) => {
  // cleanup on dismiss
  useEffect(() => {
    $('#addUserModal').on('hide.bs.modal', () => {
      setFirstName('');
      setLastname('');
      setEmail('');
    });
  }, []);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [userRole, setUserRole] = useState('CorporateBasic');
  // const [updatePlan, setUpdatePlan] = useState(false);

  const hideModal = () => $('#addUserModal').modal('hide');

  useEffect(() => {
    document.getElementById('CorporateBasic').checked = true;
  }, []);

  const handleAddUser = async (e) => {
    e.preventDefault();

    const userExists = usersByClient.some((user) => user.email === email)
      ? true
      : false;

    if (!emailRegex(email)) {
      notification(
        'danger',
        'Invalid Information.',
        'Please review any fields marked in red.',
        undefined,
        3.5
      );
    } else if (userExists) {
      notification(
        'info',
        'Invalid Information.',
        'User already exists in account.',
        undefined,
        5
      );
    } else {
      await InviteUser({
        firstName: firstName,
        lastName: lastName,
        email: email,
        phoneNumber: '',
        organisation: user.organisation,
        role: userRole,
        clientId: user.clientId,
        accountActive: true,
      });
    }
    hideModal();
  };

  return (
    <div
      className='modal user-modal'
      id='addUserModal'
      role='dialog'
      aria-hidden='true'
      data-backdrop='static'
      data-keyboard='false'
    >
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h3 className='modal-title'>Add User</h3>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleAddUser} autoComplete='off'>
              <div className='form-row m-0'>
                <div className='form-group mb-3'>
                  <label htmlFor='firstName'>First Name</label>
                  <input
                    className='form-control'
                    id='firstName'
                    type='text'
                    pattern="[`'.\-a-zA-Z ]{2,26}"
                    value={firstName ? firstName : ''}
                    required
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      if (
                        e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                        e.target.value.length < 2 ||
                        e.target.value.length > 26
                      ) {
                        e.target.setCustomValidity(
                          'Please enter a valid name.'
                        );
                      } else {
                        e.target.setCustomValidity('');
                      }
                    }}
                  />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='lastName'>Last Name</label>
                  <input
                    className='form-control'
                    id='lastName'
                    type='text'
                    pattern="[`'.\-a-zA-Z ]{2,26}"
                    value={lastName ? lastName : ''}
                    required
                    onChange={(e) => {
                      setLastname(e.target.value);
                      if (
                        e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                        e.target.value.length < 2 ||
                        e.target.value.length > 26
                      ) {
                        e.target.setCustomValidity(
                          'Please enter a valid name.'
                        );
                      } else {
                        e.target.setCustomValidity('');
                      }
                    }}
                  />
                </div>
              </div>
              <div className='form-group mb-3'>
                <label htmlFor='email'>Email</label>
                <input
                  className={`form-control${
                    email.length === 0
                      ? ''
                      : emailRegex(email)
                      ? ' is-valid'
                      : ' is-invalid'
                  }`}
                  placeholder='Email'
                  type='email'
                  id='Email'
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  maxLength={320}
                  required
                  autoComplete='off'
                />
              </div>
              <div className='form-group mt-3 mb-3'>
                <label htmlFor='userRole'>Role</label>
                <div className='d-flex flex-column'>
                  <div className='d-flex flex-row align-items-center'>
                    <input
                      type='radio'
                      id='CorporateBasic'
                      name='userRole'
                      value='CorporateBasic'
                      onChange={(e) => setUserRole(e.target.value)}
                      required
                    />
                    <label
                      className='p-1 m-0 ml-2 d-flex align-items-center cursor-pointer'
                      htmlFor='CorporateBasic'
                    >
                      Viewer
                    </label>
                  </div>
                  <p className='ml-4'>
                    Users can access RegulationCity content and its features but
                    are not allowed to add or delete users and view membership
                    information.
                  </p>
                </div>
                <div className='d-flex flex-column'>
                  <div className='d-flex flex-row align-items-center'>
                    <input
                      type='radio'
                      id='CorporateAdmin'
                      name='userRole'
                      value='CorporateAdmin'
                      onChange={(e) => setUserRole(e.target.value)}
                      required
                    />
                    <label
                      className='p-1 m-0 ml-2 d-flex align-items-center cursor-pointer'
                      htmlFor='CorporateAdmin'
                    >
                      Admin
                    </label>
                  </div>
                  <p className='ml-4'>
                    Administrators can access RegulationCity content and its
                    features, add or delete users and view membership
                    Information.
                  </p>
                </div>
              </div>

              <div className='d-flex justify-content-between'>
                <button
                  className='my-account-btn secondary'
                  onClick={hideModal}
                  type='reset'
                  data-dismiss='modal'
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className='my-account-btn'
                  type='submit'
                  disabled={
                    (firstName && lastName && email && userRole
                      ? false
                      : true) || loading
                  }
                >
                  {loading && !error ? 'Adding User' : 'Invite'}
                  {loading ? <AuthLoader /> : null}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  error: state.user.inviteError,
  user: state.user.user,
  usersByClientError: state.user.usersByClientError,
  usersByClient: state.user.usersByClient,
});

const mapDispatchToProps = { InviteUser };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(UserAddModal);
